import { getCurrentConnectionInfo } from 'portal-sdk';

/**
 * The organization domain for the current URL context (`/o/<domain>/…`), or
 * `undefined` when in a personal (`/u/…`) context. Used to scope Designer
 * projects to the org they were created under so projects don't leak between
 * org and personal views.
 */
export const getCurrentOrgDomain = (): string | undefined =>
  typeof window === 'undefined'
    ? undefined
    : getCurrentConnectionInfo(window)?.organizationDomain;
